import React, { Component } from 'react';
import Breadcrumb from "../common/breadcrumb";
import User from "../../assets/icon/user.svg"
import Wallet2 from "../../assets/icon/wallet2.png"
import Edit from "../../assets/icon/edit.svg"
import AddCredit from "../../assets/icon/wallet.svg"
import Ticket from "../../assets/icon/ticket.svg"
import Tachometer from "../../assets/icon/techometer.svg"
import Transaction from "../../assets/icon/transaction.svg"
import EditUser from "../../assets/icon/edit-user.png"
import Logout from "../../assets/icon/logout.svg"
import Gallery from "../../assets/icon/gallery.svg"
import Orders from '../orders-list/orders';
import { Helmet } from 'react-helmet';
import { GetCustomer, changePasswordApi, updateCustomer } from '../../services/api';
import Swal from 'sweetalert2'

class Dashboard extends Component {

    constructor(props) {
        super(props)
    }
    state = {
        shownPart: '',
        hash: '',
        firstName: '',
        lastName: '',
        nationalId: '',
        password: '',
        confirmPassword: '',
        oldPassword: '',
        mobile: '',
        username: ''
    }
    async componentDidMount() {
        try {
            this.setState((state) => ({ ...state, hash: window.location.hash }));
            let info = localStorage.getItem('user_info');
            if (info) {
                let customerId = JSON.parse(info)
                let data = await GetCustomer(customerId.customerID)

                let customerData = data.data.response
                this.setState((old) => ({ ...old, firstName: customerData.firstName, mobile: customerId.mobile, username: customerId.username, lastName: customerData.lastName, nationalId: customerData.nationalId }))
            }
            else {
                window.location.replace('/pages/login');
            }

        } catch (error) {

        }
    };
    componentDidUpdate(prevProps, newProps) {
        if (prevProps.history.location.hash !== this.state.shownPart) {
            this.setState(state => ({ ...state, shownPart: prevProps.history.location.hash }));
        }
    };
    goTo = (e, hash) => {
        e.preventDefault();
        this.setState((state) => ({ ...state, hash }));
        window.location.hash = hash;
    };

    logout = (e) => {
        e.preventDefault();
        window.localStorage.removeItem("user_info");
        window.location.reload(window.location.href);
    };
    changePassword = async () => {
        if (this.state.password === this.state.confirmPassword) {
            let payload = {
                Username: this.state.username,
                OldPassword: this.state.oldPassword,
                NewPassword: this.state.password,
            }
            await changePasswordApi(payload)
        } else {
            Swal.fire({
                title: '!خطا',
                text: 'رمز عبور یکسان نمی باشد',
                icon: 'error',
                confirmButtonText: 'تایید'
            })
        }

    }
    customerUpdate = async () => {
        let pay = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            nationalId: this.state.nationalId,
            mobile: this.state.mobile,
            username: this.state.username,

        }
        await updateCustomer(pay)

    }
    render() {


        return (
            <div>
                <Helmet>
                    <title>ایزی کارت 724 | پروفایل</title>
                    <meta name="description" content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses." />
                </Helmet>
                {/* <Breadcrumb title={'Dashboard'}/> */}


                {/*Dashboard section*/}
                <section className="section-b-space">
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-3 border px-0" >
                                <div className='profile-top'>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img src={User} /> <h6 > {JSON.parse(localStorage.getItem('user_info')) ? JSON.parse(localStorage.getItem('user_info')).fullName : ''}</h6>
                                        </div>
                                        <div style={{ cursor: 'pointer' }} onClick={(e) => this.goTo(e, 'edit-Profile')}>
                                            <img src={Edit} />
                                        </div>
                                    </div>
                                    {/* <div className='mt-2 mr-4 mb-1'>
                                        <a href="#" data-lng="en">
                                            <div className='icon-box'>
                                                <img src={Wallet2} />

                                            </div>
                                            <span style={{ color: 'red' }}>

                                                0 تومان
                                            </span>
                                        </a>
                                    </div> */}
                                </div>
                                <div className='menu-items'>
                                    <a href='#' onClick={(e) => this.goTo(e, '')} className='menu-item' >
                                        <div className='icon-box'>
                                            <i class="fa fa-tachometer" aria-hidden="true"></i>

                                        </div>
                                        پیشخوان
                                    </a>
                                    {/* 
                                    <div className='menu-item'>

                                        <div className='icon-box'>
                                            <img src={AddCredit} />

                                        </div>
                                        افزودن اعتبار
                                    </div> */}

                                    {/* <div className='menu-item'>

                                        <div className='icon-box'>
                                            <img src={Transaction} />

                                        </div>
                                        تراکنش ها
                                    </div> */}
                                    <a href='#' onClick={(e) => this.goTo(e, 'edit-Profile')}  className={this.state.hash === 'edit-Profile' || this.state.shownPart === '#edit-Profile' ? 'menu-active-item' : 'menu-item'}>
                                        <div className='icon-box'>
                                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                        </div>
                                        ویرایش پروفایل
                                    </a>
                                    <a href='#' onClick={(e) => this.goTo(e, 'orders')} className={this.state.hash === 'orders' || this.state.shownPart === '#orders' ? 'menu-active-item' : 'menu-item'} >
                                        <div className='icon-box'>
                                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                                        </div>
                                        سفارشات
                                    </a>

                                    {/* <div className='menu-item'>

                                        <div className='icon-box'>
                                            <img src={Ticket} />

                                        </div>
                                        تیکت ها
                                    </div> */}

                                    <div className='menu-item' onClick={this.logout}>
                                        <div className='icon-box'>
                                            <i class="fa fa-sign-out" aria-hidden="true"></i>


                                        </div>
                                        خروج
                                    </div>

                                </div>


                            </div>
                            <div className="col-lg-9">

                                <div className="dashboard-right">
                                    {this.state.shownPart === '#edit-Profile' &&
                                        <div className="dashboard">
                                            <div className="page-title">
                                                <h2>ویرایش اطلاعات شخصی</h2>
                                            </div>
                                            <div className="welcome-msg">

                                            </div>

                                            <div className="box-account box-info">

                                                <div className="row">
                                                    <div className="col-sm-12 col-md-6 col-lg-6">
                                                        <div className="box">
                                                            <div className="box-title">
                                                                <h3>تصویر پروفایل</h3>
                                                            </div>
                                                            <div className="box-content text-center">
                                                                <img src={User} />
                                                                <div className='mt-2' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ff8400' }}>
                                                                    <img src={Gallery} />
                                                                    <h6 className='text-center mr-2' style={{ color: '#ff8400' }}>انتخاب تصویر</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 col-md-6 col-lg-6 mt-2">
                                                        <div className="box">
                                                            <div className="box-title">
                                                                <h3>تغییر رمز عبور</h3>
                                                            </div>
                                                            <div className="box-content">
                                                                <div>
                                                                    <label htmlFor="review">رمز عبور</label>
                                                                    <input type="password" value={this.state.oldPassword} onChange={(e) => this.setState({ oldPassword: e.target.value })} className="form-control" required="" />
                                                                </div>
                                                                <div className='d-flex' style={{ gap: '2px' }}>
                                                                    <div>
                                                                        <label htmlFor="review">رمز عبور جدید</label>
                                                                        <input value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })} className="form-control" type="password" required="" />
                                                                    </div>
                                                                    <div>
                                                                        <label htmlFor="review">تکرار رمز عبور</label>
                                                                        <input className="form-control" value={this.state.confirmPassword} onChange={(e) => this.setState({ confirmPassword: e.target.value })} type="password" required="" />
                                                                    </div>

                                                                </div>

                                                                <div className='text-left'>
                                                                    <div className="btn btn-secondary mt-2" onClick={this.changePassword} style={{ color: '#ffffff' }}>ثبت</div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12  mt-4">
                                                        <div className="box">
                                                            <div className="box-title">
                                                                <h3>اطلاعات پایه</h3>
                                                            </div>
                                                            <div className="box-content">
                                                                <form className="theme-form">
                                                                    <div className="form-row">
                                                                        <div className="col-md-6">
                                                                            <label htmlFor="email">نام</label>
                                                                            <input type="text" className="form-control" id="fname"
                                                                                value={this.state.firstName} onChange={(e) => this.setState({ firstName: e.target.value })}
                                                                                required="" />
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <label htmlFor="review">نام خانوادگی</label>
                                                                            <input className="form-control" value={this.state.lastName} onChange={(e) => this.setState({ lastName: e.target.value })} type="text" required="" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-row">
                                                                        <div className="col-md-6">
                                                                            <label htmlFor="email">کد ملی</label>
                                                                            <input type="text" className="form-control"
                                                                                value={this.state.nationalId} onChange={(e) => this.setState({ nationalId: e.target.value })}
                                                                                required="" />
                                                                        </div>


                                                                    </div>   <div className='form-row'>
                                                                        <div className="col-md-6"></div>
                                                                        <div className="col-md-6">

                                                                            <div className="btn btn-solid mt-3 float-left" onClick={this.customerUpdate}>ثبت</div>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>
                                        </div>
                                    }
                                    {this.state.shownPart === '#orders' &&
                                        <div className="dashboard">
                                            <div className="page-title">
                                                <h2>مشاهده سفارشات</h2>
                                            </div>
                                            <Orders></Orders>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default Dashboard